import { init } from '@rematch/core';
// import user from './user';
import loginInfo from './loginInfo';
import userInfo from './userInfo';

// 先尝试从本地恢复信息
const localLoginInfo = localStorage.getItem('user:loginInfo');
const localUserInfo = localStorage.getItem('user:userInfo');
// if (localLoginInfo !== null) {
//   store.dispatch.loginInfo.saveLoginInfo(JSON.parse(localLoginInfo));
// }

const store = init({
  models: {
    // user,
    userInfo,
    loginInfo,
  },
  redux: {
    initialState: {
      userInfo: localUserInfo === null ? null : JSON.parse(localUserInfo),
      // loginInfo: localLoginInfo === null ? initLoginInfo : JSON.parse(localLoginInfo),
    }
  }
});

if (localLoginInfo) {
  store.dispatch.loginInfo.saveLoginInfo(JSON.parse(localLoginInfo));
}

export default store;
